/*!
 *
 *	menu.js
 *
 */

var menu = {
	init: function(){
		this.$btn = $('#menu_btn a');
		this.$menu = $('#menu');
		this.$inner = $('#menu_inner');
		this.$wrapper = $('#wrapper');
		this.isOpen = false;
		this.setHeight();
		this.events();
	},
	events: function(){
		var self = this;
		this.scrollTop = null;

		this.$btn.on('tap', function(e){
			e.preventDefault();
			if( self.isOpen ){
				self.isOpen = false;
				self.$wrapper.removeAttr('style');
				$(origin.st).scrollTop(self.scrollTop);
				self.$menu.slideUp(500);
			}else{
				self.isOpen = true;
				self.scrollTop = origin.$window.scrollTop();
				self.$wrapper.css({
					'position': 'fixed',
					'top': -self.scrollTop,
					'left': 0,
					'right': 0
				});
				self.$menu.slideDown(500);
			};
		});

		origin.$window.on('resize', function(){
			self.setHeight();
		});
	},
	setHeight: function(){
		var self = this,
			h = origin.$window.innerHeight() - 65;
		this.$inner.css('max-height', h);
	}
};

module.exports = menu;


//////////////////
// WEBPACK FOOTER
// ./dev/js/components/module/menu.js
// module id = 16
// module chunks = 0